export default __webpack_public_path__ + "assets/images/33d5ed9834fcb73762b38c32512ccf99.svg";